import logo from './logo.svg';
import './App.css';
import React,{useEffect} from 'react'
import {Routes,Route, useNavigate} from 'react-router-dom'
import Home from './Pages/Home';
import CategoryVideo from './Pages/CategoryVideo';
import VideoPage from './Pages/VideoPage';
import Footer from './Components/Footer';
import Subscribe from './Pages/Subscribe';
import Faq from './Pages/Faq';
import SelectPack from './Pages/SelectPack';
import 'primeicons/primeicons.css';
import { PrimeReactProvider } from 'primereact/api';
// import 'primeflex/primeflex.css';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import GetHeaders from './Pages/GetHeaders';
import { v4 as uuidv4 } from 'uuid';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'
import Auth from './Pages/Auth';
import ProgressSub from './Pages/ProgressSub';
import MisData from './Pages/MisData';
import Redirect from './Pages/Redirect';
import Profile from './Pages/Profile';
import Cookies from 'js-cookie';
import { generateRandomString } from './Components/RandomStringGenerator';
import PromotionData from './Pages/PromotionData';
import CheckPage from './Pages/CheckPage';
// import { toast } from 'react-toastify';





function App() {


  const RedirectPage=()=>{
     const params = new URLSearchParams(window.location.search)
      const extId = params.get('ext_ref') || generateRandomString();

      console.log(extId)
    
     const navigate = useNavigate()

     Cookies.remove('sub_number')
      
      useEffect(()=>{
        // window.location.href = `http://seenvd.com/api/header?ext_ref=${extId}`
        // const res = await axios.post(`http://seenvd.com/api/header?ext_ref=${extId}`)
        // console.log(res.data)

        navigate(`/home?ext_ref=${extId}`)
      },[])
    return (
      <></>
    )
  }

 

  return (
    <>
    <Routes>
    <Route path="/" element={<RedirectPage/>}/>
    <Route path='/home' element={ <Home/>} />
    <Route path='/home/:artist' element={ <Home/>} />
    <Route path='/videos/:category' element={<><CategoryVideo/></>} />
    <Route path='/Video/:id' element={<><VideoPage/></>} />
    <Route path='/subscribe' element={<Subscribe/>}/>
    <Route path='/faq' element={<Faq/>} />
    <Route path='/pack' element={<SelectPack/>} />
    <Route path='/header' element={<GetHeaders/>}/>
    <Route path='/progress' element={<ProgressSub/>}/>
    <Route path='/mis-data' element={<MisData/>}/>
    <Route path='/promotion-data' element={<PromotionData/>}/>
    <Route path='/redirect' element={<Redirect/>}/>
    <Route path='/profile' element={<Profile/>} />

    <Route path='/check' element={<CheckPage/>} />


    <Route />

    </Routes>
    <ToastContainer/>
    <Footer/>
    </>
  );
}

export default App;
